export function parseMatchLog(text) {
  const teamHeaderRe =
    /^TeamName:\s*(.*?)\s+Rank:\s*(\d+)\s+KillScore:\s*(\d+)\s+RankScore:\s*(\d+)\s+TotalScore:\s*(\d+)\s*$/u;
  const playerRe = /^NAME:\s*(.+?)\s+ID:\s*([0-9]+)\s+KILL:\s*(\d+)\s*$/u;
  const normalizeText = (t) => t.replace(/^\uFEFF/, "").replace(/\r\n/g, "\n");
  const normalizeLine = (s) =>
    s.replace(/^[\uFEFF\u200B\u200C\u200D]+/, "").trimEnd();

  const lines = normalizeText(text).split("\n");
  const teams = [];
  let current = null;
  for (const raw of lines) {
    const line = normalizeLine(raw);
    if (!line) continue;
    const tm = teamHeaderRe.exec(line);
    if (tm) {
      if (current) teams.push(current);
      const [, teamNameRaw, rank, killScore, rankScore, totalScore] = tm;
      current = {
        teamName: (teamNameRaw || "").trim() || null,
        rank: Number(rank),
        scores: {
          killScore: +killScore,
          rankScore: +rankScore,
          totalScore: +totalScore,
        },
        players: [],
      };
      continue;
    }
    const pm = playerRe.exec(line);
    if (pm && current) {
      const [, name, id, kills] = pm;
      current.players.push({
        name: name.trim(),
        id: String(id).trim(),
        kills: +kills,
      });
    }
  }
  if (current) teams.push(current);
  return teams;
}
